import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchProjectDetailApi, updateProjectApi, fetchProjectHistoryApi, updateProjectStatusApi, addProjectManagersApi } from "../../API/API";

function* fetchProjectDetailSaga(params) {
  try {
    const response = yield call(() => fetchProjectDetailApi(params));
    yield put({
      type: types.FETCH_PROJECT_DETAIL_SUCCESS,
      payload: {
        project: response.data?.data?.project || null,
        jobs: response.data?.data?.jobs?.data || [],
        counts: response.data?.data?.counts || {},
        talents: response.data?.data?.talents?.data || [],
        talentsCount: response.data?.data?.talents?.count || 0,
        managers: response.data?.data?.managers?.data || [],
        managersCount: response.data?.data?.managers?.count || 0,
      },
    });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_DETAIL_FAILURE, error });
  }
}

function* updateProjectSaga(params) {
  try {
    yield call(() => updateProjectApi(params));
    yield put({ type: types.UPDATE_PROJECT_SUCCESS });
  } catch (error) {
    yield put({ type: types.UPDATE_PROJECT_FAILURE, error });
  }
}

function* fetchProjectHistorySaga(params) {
  try {
    const response = yield call(() => fetchProjectHistoryApi(params));
    yield put({
      type: types.FETCH_PROJECT_HISTORY_SUCCESS,
      payload: response.data?.data?.history || [],
    });
  } catch (error) {
    yield put({ type: types.FETCH_PROJECT_HISTORY_FAILURE, error });
  }
}

export function* watchFetchProjectDetailSaga() {
  yield takeLatest(types.FETCH_PROJECT_DETAIL_INIT, fetchProjectDetailSaga);
}

export function* watchUpdateProjectSaga() {
  yield takeLatest(types.UPDATE_PROJECT_INIT, updateProjectSaga);
}

function* addProjectManagersSaga(params) {
  try {
    yield call(() => addProjectManagersApi(params));
    yield put({ type: types.ADD_PROJECT_MANAGERS_SUCCESS });
    yield put({ type: types.FETCH_PROJECTS_INIT });
  } catch (error) {
    yield put({ type: types.ADD_PROJECT_MANAGERS_FAILURE, error });
  }
}

export function* watchFetchProjectHistorySaga() {
  yield takeLatest(types.FETCH_PROJECT_HISTORY_INIT, fetchProjectHistorySaga);
}

export function* watchAddProjectManagersSaga() {
  yield takeLatest(types.ADD_PROJECT_MANAGERS_INIT, addProjectManagersSaga);
}

function* updateProjectStatusSaga(params) {
  try {
    yield call(() => updateProjectStatusApi(params));
    yield put({ type: types.UPDATE_PROJECT_STATUS_SUCCESS });
    yield put({ type: types.FETCH_PROJECTS_INIT });
  } catch (error) {
    yield put({ type: types.UPDATE_PROJECT_STATUS_FAILURE, error });
  }
}

export function* watchUpdateProjectStatusSaga() {
  yield takeLatest(types.UPDATE_PROJECT_STATUS_INIT, updateProjectStatusSaga);
}
